/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpHead_viewer = {
    readonly isPdpUrlTranslationEnabled?: boolean | null;
    readonly " $refType": "PdpHead_viewer";
};
export type PdpHead_viewer$data = PdpHead_viewer;
export type PdpHead_viewer$key = {
    readonly " $data"?: PdpHead_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpHead_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpHead_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchPdp",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "isPdpUrlTranslationEnabled",
          "name": "isEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "translatedPdpUrls"
            }
          ],
          "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
        }
      ]
    }
  ]
};
(node as any).hash = '212bdcefa3a647a7499cd65731f14454';
export default node;
